var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-navigation-drawer',{attrs:{"width":_vm.width,"color":"#fafbfc","fixed":"","right":"","temporary":"","touchless":""},model:{value:(_vm.realValue),callback:function ($$v) {_vm.realValue=$$v},expression:"realValue"}},[_c('no-chain-scroll-container',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }